/**
 * isValidURL
 *
 * Checks if a string is a valid url
 *
 * @param {string} string input
 *
 * @return {boolean} boolean output
 */
export function isValidURL(string) {
  let valid;

  try {
    valid = !!new URL(string);
  } catch (_) {
    valid = false;
  }

  return valid;
}
